import { useQuery } from '@tanstack/react-query';

import { getPlants, getPlantsBasic, getPlantStatuses, getPlantsWithProducts } from '../api';
import { type Plant } from '../types';

export const USE_PLANTS_KEY = 'usePlants';
export const USE_PLANTS_BASIC_KEY = 'usePlantsBasic';
export const USE_PLANTS_WITH_PRODUCTS_KEY = 'usePlantsWithProducts';
export const USE_PLANT_STATUSES_KEY = 'usePlantStatuses';

export const usePlants = (enabled = true) =>
  useQuery({
    queryKey: [USE_PLANTS_KEY],
    queryFn: getPlants,
    staleTime: 1000 * 60 * 5,
    enabled,
  });

export const usePlantsBasic = (enabled = true) =>
  useQuery({
    queryKey: [USE_PLANTS_BASIC_KEY],
    queryFn: getPlantsBasic,
    staleTime: 1000 * 60 * 5,
    enabled,
  });

export const usePlantsWithProducts = (initialData?: Plant[]) =>
  useQuery({
    queryKey: [USE_PLANTS_WITH_PRODUCTS_KEY],
    queryFn: getPlantsWithProducts,
    staleTime: 1000 * 60 * 5,
    initialData,
  });

export const usePlantStatuses = () =>
  useQuery({
    queryKey: [USE_PLANT_STATUSES_KEY],
    queryFn: getPlantStatuses,
    staleTime: 1000 * 60 * 60,
  });
